module.exports = {
	"articleTitle1": "Faking 21: How bouncers catch fake IDs and underage students get ...",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Bar Louie",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/content/flies-dirty-knives-local-restaurants-make-changes-after-health-code-violations",
	"articleSnippet1": "Sep 5, 2011 ... A few tables are open, and the crowd at the bar is only one person deep. .... I've \nturned 21 — the other was Bar Louie on East Liberty Street.",
	"articleSnippet2": "Nov 5, 2010 ... Anna Schulte/Daily: Bar Louie Assistant Kitchen Manager J.R. Hernandez makes \nsure to wear gloves as he prepares a special shrimp dish on ...",
	"foodRecommendations": [
		{
			"text": "Known for their happy hour specials",
			"person": "Ian McKenzie"
		}
	],
	"articleTitle2": "Restaurants make fixes to address code violations",
	"address": "401 E Liberty St #200, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2796,
		"lng": -83.7438
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/barlouie.json
// module id = 822
// module chunks = 0